<div
  (click)="onBuyerCardClick()"
  [ngClass]="buyerCardClass"
  class="buyer-card {{ showSimulation ? 'simulated' : 'nonSimulated' }}">
  <div class="top-bar">
    <img
      [alt]="cohort.buyer.name"
      [ngClass]="cohort.buyer.shortName"
      [src]="getOpenAssetURL(cohort.buyer.shortName, 'logo.svg')" />
    <div class="total-annual-value">
      Estimated Average Annual Revenue:
      <div class="value">
        {{ averageValuePerYear | currency: 'USD' }}
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>
  <div class="info-section">
    <div class="info">
      <div class="info-left">Frequency of Payments</div>
      <div class="info-right">
        <span>{{ paymentFrequency }}</span>
      </div>
    </div>
    <div *ngIf="!showSimulation" class="info">
      <div class="info-left">Estimated Payment</div>
      <div class="info-right">
        <span class="paymentAmount">
          {{ baseValuePerYear / (12 / cohort.payPeriodCadence) | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your estimated payment during the promotion period. Your actual payment will follow the frequency listed above, and could be more or less than this amount, depending on the terms of your contract.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div *ngIf="showSimulation" class="info">
      <div class="info-left">Estimated Payment During Fixed-Rate Period</div>
      <div class="info-right">
        <span class="paymentAmount">
          {{ fixedAnnualPayment | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your estimated payment during the promotion period. Your actual payment will follow the frequency listed above, and could be more or less than this amount, depending on the terms of your contract.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div *ngIf="showSimulation" class="info">
      <div class="info-left">Total Payments Through Fixed-Rate Period</div>
      <div class="info-right">
        <span class="fixed-period-value">
          {{ totalFixedPayment | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="projectionInfoBox((cohort.initialFixedYears + todayYear).toString(), false)"
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>
  <div></div>
  <div class="info-section">
    <div *ngIf="showSimulation" class="info">
      <div class="info-left">
        <div>Interactive Rate Simulator</div>
        <div class="slider-div">
          <mat-slider class="simulation-slider" max="15" min="-5" step="1">
            <input
              matSliderThumb
              (input)="newSliderValue(ngSliderThumb.value)"
              #ngSliderThumb="matSliderThumb"
              data-cy="rate-slider"
              value="0" />
          </mat-slider>
        </div>
      </div>
      <div class="info-right simulation-slider-div">
        <span>
          <fa-icon
            #tooltip3="matTooltip"
            (click)="tooltip3.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This simulator allows you to see how your revenue could be impacted by the rising and falling of carbon prices. Use the slider to simulate what your potential earnings could be given a variable rate model.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
        <span>%</span>
        <span data-cy="slider-value">{{ ngSliderThumb.value }}</span>
      </div>
    </div>
    <div class="info">
      <div class="info-left">
        {{ showSimulation ? 'Simulated' : 'Total' }} Projection Through
        {{ twentyYearMark }}
      </div>
      <div class="info-right">
        <span class="twenty-year-projection">
          {{ twentyYearProjection | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="projectionInfoBox(twentyYearMark, showSimulation)"
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>
  <div class="terms">
    <div class="overview-terms">Overview of Terms</div>
    <div class="term-list">
      <ul class="terms">
        <li>{{ cohort.terms1 }}</li>
        <li *ngIf="cohort.terms2">{{ cohort.terms2 }}</li>
        <li *ngIf="cohort.terms3">{{ cohort.terms3 }}</li>
      </ul>
    </div>
    <a *ngIf="cohort.termsUrl" [href]="cohort.termsUrl" class="fc-link" target="_blank">
      <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue"></fa-icon>
      See additional {{ cohort.buyer.name }} terms
    </a>
  </div>
  <div class="selected-container">
    <div *ngIf="cohort === selectedCohort; else selectButton">
      <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Active"></fa-icon>
      <div>Selected</div>
    </div>
    <ng-template #selectButton>
      <button color="primary" mat-stroked-button>Select</button>
    </ng-template>
  </div>
</div>
